export const contactsData = {
  Bulgaria: [
    {
      name: 'Regional Agency for Entrepreneurship and Innovations – Varna (RAPIV)',
      countryRegion: 'Bulgaria',
      address: '',
      email: 'office@rapiv.org',
      website: 'office@rapiv.org'
    },
    {
      name: 'Varna Free University “Chernorizets Hrabar” (VFU)',
      countryRegion: 'Bulgaria',
      address: '',
      email: 'edu@vfu.bg',
      website: 'https://www.vfu.bg/en/'
    }
  ],

  Austria: [
    {
      name: 'Innovation Region Styria LTD (IRS)',
      countryRegion: 'Austria',
      address: '',
      email: 'office@irstyria.at',
      website: 'http://www.irstyria.at/'
    }
  ],

  Croatia: [
    {
      name: 'Technology Park Varaždin ltd',
      countryRegion: 'Croatia',
      address: '',
      email: 'info@techpark.hr',
      website: 'https://techpark.hr/'
    }
  ],

  Czechia: [
    {
      name: 'IREAS, Institute for Structural Policy, o. p. s.',
      countryRegion: 'Czechia',
      address: '',
      email: 'office@ireas.cz',
      website: 'https://www.ireas.cz/en/'
    }
  ],

  Germany: [
    {
      name: 'Bwcon GmbH',
      countryRegion: 'Germany',
      address: '',
      email: 'info@bwcon.de',
      website: 'https://www.bwcon.de/'
    }
  ],

  Slovenia: [
    {
      name: 'Chamber of Commerce and Industry of Štajerska',
      countryRegion: 'Slovenia',
      address: '',
      email: 'info@stajerskagz.si',
      website: 'https://www.stajerskagz.si/en/'
    }
  ],

  Hungary: [
    {
      name: 'Pannon Business Network Association (PBN)',
      countryRegion: 'Hungary',
      address: '',
      email: 'info@pbn.hu',
      website: 'https://www.pbn.hu/'
    },
    {
      name: 'Hungarian Economic Development Agency (MGFÜ)',
      countryRegion: 'Hungary',
      address: '',
      email: 'nemzetkozi@mgfu.hu',
      website: 'https://mgfu.hu/'
    }
  ],

  Romania: [
    {
      name: 'Ropot Boutique SRL',
      countryRegion: 'Romania',
      address: '',
      email: 'contact@impacthub.ro',
      website: 'https://impacthub.ro/'
    }
  ],

  Slovakia: [
    {
      name: 'Slovak Business Agency (SBA)',
      countryRegion: 'Slovakia',
      address: '',
      email: 'agency@sbagency.sk',
      website: 'https://www.sbagency.sk/'
    }
  ],

  Moldova: [
    {
      name: 'Organization for Entrepreneurship Development (ODA)',
      countryRegion: 'Moldova',
      address: '',
      email: 'office@oda.md',
      website: 'https://www.oda.md/'
    }
  ],

  'Bosnia and Herzegovina': [
    {
      name: 'Foreign Trade Chamber of Bosnia and Herzegovina',
      countryRegion: 'Bosnia and Herzegovina',
      address: '',
      email: 'info@komorabih.ba',
      website: 'https://komorabih.ba/'
    },
    {
      name: 'University of Sarajevo',
      countryRegion: 'Bosnia and Herzegovina',
      address: '',
      email: 'javnost@unsa.ba',
      website: 'https://unsa.ba/en'
    }
  ],

  Serbia: [
    {
      name: 'Association of Business Women in Serbia (ABW)',
      countryRegion: 'Serbia',
      address: '',
      email: 'office@poslovnezene.org.rs',
      website: 'https://poslovnezene.org.rs/en/home-2/'
    }
  ]
}
